angular.module('swapick')
.controller('HomeCategoriesCtrl', HomeCategoriesCtrl);


function HomeCategoriesCtrl($scope, DataService, $ionicLoading, 
  ionPullUpFooterState, $timeout, $ionicScrollDelegate, 
  Filters, Categories, initialLoaderManager, $q, $state, $ionicHistory) {

  
  
  this.loader = initialLoaderManager.makeLoader(() => {
    return Categories.getCategories()
    .then(categories => {
      this.categoriesData = Categories.data;
      return this.categoriesData;
    })


  }, false);

  $scope.$on('$ionicView.afterEnter', () => {
      if(!this.categoriesData){
        this.loader.load();
      }
  });


  this.toHome = (idCat, idWorld) => {
    $ionicHistory.nextViewOptions({
      disableBack: true,
      historyRoot : true,
    });
    Filters.setFilter('home.mondo', idWorld);
    Filters.setFilter('home.categoria', idCat);
    $state.go("app.logged.home", { cat:idCat, world:idWorld})
  }


  
}




// WEBPACK FOOTER //
// ./src/controllers/home-categories-controller.js